const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoneyDisplay(value: string | number): string {
  const numeric = typeof value === "number" ? value : parseMoneyValue(value);
  if (Number.isNaN(numeric)) return "";
  return currencyFormatter.format(numeric);
}

export function parseMoneyValue(raw: string): number {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return Number.NaN;
  return Number(digits) / 100;
}

export function moneyValueToDecimalString(value: number): string {
  if (Number.isNaN(value)) return "";
  return value.toFixed(2);
}

export function createMoneyChangeEvent(decimalString: string): React.ChangeEvent<HTMLInputElement> {
  return {
    target: { value: decimalString },
  } as React.ChangeEvent<HTMLInputElement>;
}
